export default "__VITE_ASSET__DJXI28Y$__"